const CHANNEL_NAME = 'ecomm2-auth'

export type AuthBroadcastMessage = { type: 'logout' }

type Listener = (msg: AuthBroadcastMessage) => void

let channel: BroadcastChannel | null = null
let listeners: Listener[] = []

function getChannel(): BroadcastChannel | null {
  if (typeof window === 'undefined') return null
  if (typeof BroadcastChannel === 'undefined') return null
  if (channel) return channel
  try {
    channel = new BroadcastChannel(CHANNEL_NAME)
    channel.addEventListener('message', evt => {
      const msg = evt.data as AuthBroadcastMessage | undefined
      if (!msg || typeof msg.type !== 'string') return
      listeners.forEach(l => {
        try {
          l(msg)
        } catch (err) {
          console.error('[auth-broadcast] listener threw', err)
        }
      })
    })
  } catch {
    channel = null
  }
  return channel
}

export function broadcastAuth(message: AuthBroadcastMessage): void {
  try {
    getChannel()?.postMessage(message)
  } catch (err) {
    console.error('[auth-broadcast] postMessage failed', err)
  }
}

export function subscribeAuth(listener: Listener): () => void {
  getChannel()
  listeners.push(listener)
  return () => {
    listeners = listeners.filter(l => l !== listener)
  }
}
